<template>
  <v-app>
    <!-- Top Bar with Menu Toggle Button -->
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>NPCode App</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        variant="text"
        color="white"
        class="mr-2"
        @click="$router.push('/report-bug')"
      >
        Report a Bug
      </v-btn>
      <v-btn
        icon
        href="https://wa.me/96176469052"
        target="_blank"
        rel="noopener"
        aria-label="Contact on WhatsApp"
      >
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Side Menu as a Drawer -->
    <v-navigation-drawer app v-model="drawer" permanent width="256">
      <div class="brand-section">
        <v-icon size="36" color="primary">mdi-alpha-n-circle</v-icon>
        <div>
          <div class="brand-title">NazirProg</div>
          <div class="brand-subtitle">Coding Utilities</div>
        </div>
      </div>
      <v-divider></v-divider>
      <v-list>
        <v-list-item-group>
          <v-list-item to="/" router>
            <v-list-item-content>Home Page (Dashboard)</v-list-item-content>
          </v-list-item>
          <v-list-item to="/remove-comas" router>
            <v-list-item-content>Remove Comas</v-list-item-content>
          </v-list-item>
          <v-list-item to="/add-comas" router>
            <v-list-item-content>Add Comas</v-list-item-content>
          </v-list-item>
          <v-list-item to="/sgde-to-aed" router>
            <v-list-item-content>SGDE -> AED Converter</v-list-item-content>
          </v-list-item>
          <v-list-item to="/vcx-to-aed" router>
            <v-list-item-content>VCX -> AED Converter</v-list-item-content>
          </v-list-item>
          <v-list-item to="/report-bug" router>
            <v-list-item-content>Report a Bug</v-list-item-content>
          </v-list-item>
          <!-- New menu item for Add Comas -->
        </v-list-item-group>
      </v-list>
      <div class="copyright-note">
        © {{ currentYear }} NazirProg. All rights reserved.
      </div>
    </v-navigation-drawer>

    <!-- Main Content -->
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: true, // Controls the visibility of the side menu
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style>
/* Custom styles can be added here */
.brand-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}

.brand-title {
  font-weight: 600;
  font-size: 1.1rem;
}

.brand-subtitle {
  font-size: 0.8rem;
  color: #666;
}

.copyright-note {
  margin-top: auto;
  padding: 16px;
  font-size: 0.75rem;
  color: #777;
}
</style>
